import Carousel from '../modules/carousel'

$.fn.Timeline = function() {
  let self = $(this)
  self.carousel = undefined
  self.el = {
    swiper: self.find('.timeline__slider'),
  }

  /* Create carousel */
  self.create_carousel = function() {
    self.carousel = new Carousel(self.el.swiper.get(0), {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      breakpoints: {
        768: {
          slidesPerView: parseInt(self.data('cols')),
          spaceBetween: 0,
          autoHeight: false,
        },
      },
      slideToClickedSlide: true,
    })
    self.carousel.init()
  }

  return function() {
    self.create_carousel()
    return self
  }()
}
